import { render } from "./DictionaryValueForm.vue?vue&type=template&id=77dc6217"
import script from "./DictionaryValueForm.vue?vue&type=script&lang=js"
export * from "./DictionaryValueForm.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__